<template>
	<div class="page">
		<div style="width: 100%; height: 200px;">
			<div class="ditem01">
				<div class="item01L">
					<div class="localArrowImg"></div>
				</div>
				
				<p class="item01R" style="word-break:break-all;">{{work.orderName}}</p>
			</div>
			<div class="ditem02">
				<div class="item02Cell"><span class="cellTit">工&nbsp;&nbsp;单&nbsp;号：&nbsp;&nbsp;&nbsp;</span><span class="cellCont">{{work.orderId}}</span></div>
				<div class="item02Cell"><span class="cellTit">责&nbsp;&nbsp;任&nbsp;人：&nbsp;&nbsp;&nbsp;</span><span class="cellCont">{{work.orderChargePerson}}</span></div>
				<div class="item02Cell"><span class="cellTit">创建时间：&nbsp;&nbsp;&nbsp;</span><span class="cellCont">{{work.orderCreateTime}}</span></div>
			</div>
			<div class="ditem02" v-if="device">
				<div class="item02Cell"><span class="cellTit">设备名称：&nbsp;&nbsp;&nbsp;</span><span class="cellCont">{{device.deviceName}}</span></div>
				<div class="item02Cell"><span class="cellTit">IP地址：&nbsp;&nbsp;&nbsp;</span><span class="cellCont">{{device.deviceIp}}</span></div>
				<div class="item02Cell"><span class="cellTit">设备版本：&nbsp;&nbsp;&nbsp;</span><span class="cellCont">{{device.deviceVersion}}</span></div>
			</div>
			<div class="ditem03">
				<div class="item02Cell"><span class="cellTit">问题描述：&nbsp;&nbsp;&nbsp;</span><span class="cellCont">{{work.orderDesc}}</span></div>
				<div class="item02Cell"><span class="cellTit">处理进展：&nbsp;&nbsp;&nbsp;</span>
					<span class="cellCont" v-if="process.length==0">无进展消息</span>
					<div class="cellCont" v-else>
						<div v-for="(item,index) in process">
							<div>
								<span :class="index==0?'cont-circle':'cont-circle-grey'"></span>
								<span class="cont-content">{{item.procContent}}</span>
							</div>
							<div>
								<span class="cont-border"></span>
								<span class="cont-time">{{item.procTime+'  '+item.procHandlePerson}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="item02Cell"><span class="cellTit">解决方案：&nbsp;&nbsp;&nbsp;</span>
					<span class="cellCont" v-if="solution.fundReason==null">无解决方案</span>
					<div class="cellCont" v-else>
						<div >
							<div>
								<span class="cont-circle"></span>
								<span class="cont-content">{{'根本原因:'+solution.fundReason}}</span>
							</div>
							<div>
								<span class="cont-circle"></span>
								<span class="cont-content">{{'解决方案:'+solution.solvedSolution}}</span>
							</div>
							<div>
								<span class="cont-border"></span>
								<span class="cont-time">{{solution.createdTime}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="item02Cell01" style=""><span class="cellTit">是否关闭：&nbsp;&nbsp;&nbsp;</span><div class="cellCont01">
					<div  class="radioUp" :class="{radioPress:isRadio}"></div><span class="radioTxt">是</span>
					<div  class="radioUp" :class="{radioPress:!isRadio}"></div><span class="radioTxt" >否</span>
				</div></div>
			</div>
			
		</div>
	</div>
</template>
<script>
	import {_api} from '@/service/interface'
	export default{
		name:'WcWorkD',
		data(){
			return{
				isRadio:null,
				radioUp:false,
				order:this.$route.query.id,
				work:{orderName:'',orderId:'',orderChargePerson:'',orderCreateTime:'',orderDesc:''},
				process:[],
				solution:{fundReason:null},
				device:null
			}
		},
		methods:{
			changeRadio(){
				this.isRadio = !this.isRadio;
			},
			getCurPathId(){
				var selectedId = this.$route.query.selectedId;
				console.log("当前的Id的是",selectedId)
			},
			getOrder(){
				_api('_order','.code',{params:{mark:'getDetails',order:this.order}},res=>{
					this.work=res.data.baseInfo;
					this.process=res.data.procProgList;
					if(res.data.solvedSolutionInfo){
						this.solution=res.data.solvedSolutionInfo;
					}
					if(res.data.deviceInfo){
						this.device = res.data.deviceInfo;
					}
					this.isRadio=["5","6","7"].includes(this.work.orderStatus)
				},err=>{
					
				})
			}
		},
		mounted(){
			this.getCurPathId();
			this.getOrder();
		}
	}
</script>
<style>
	body{
		width: 100%;
		height: 100%;
		background-size: 100% 100%;
	}
	.page{
		padding-top: 1px;
		position: relative;
		top: 40px;
		font-size: 14px;
	}
	.ditem01{
		height: auto;
		margin-top: 10px;
		background: #FFFFFF;
		border-top: 1px solid #DBDBDB;
		box-shadow:2px 2px 10px #D1D1D1;
		padding-left: 20px;
		padding-right: 20px;
		display: flex;
		padding-top: 10px;
		padding-bottom: 10px;
		color: #4E4E4E;
	}
	.item01L{
		padding-top:5px;
		width: 20px;
		margin-right: 10px;
		
	}
	.cont-time{
		font-size: 12px;
	}
	.item01R{
		height: auto;
		line-height: 30px;
	}
	.localArrowImg{
		width: 20px;
		height: 18px;
		background:url(../../../assets/images/img01.png);
		background-size: 20px 18px;
		float: right;
	}
	.ditem02,.ditem03{
		height: auto;
		border-top: 1px solid #DBDBDB;
		box-shadow: 2px 2px 10px #D1D1D1;
		background: #FFFFFF;
		margin-top: 15px;
		padding:10px 20px;
	}
	.item02Cell{
		line-height: 40px;
		display: flex;
	}
	.item02Cell01{
		line-height: 40px;
		display: flex;
	}
	.cellTit{
		color: #828282;
		flex: 2;
		white-space: nowrap;
	}
	.cellCont{
		color: #4C4C4C;
		flex: 8;
	}
	.radioUp{
		width: 16px;
		height: 16px;
		background: url(../../../assets/images/radio.png);
		background-size:16px 16px ;
	}
	.radioPress{
		width: 16px;
		height: 16px;
		background: url(../../../assets/images/radiounpress.png);
		background-size:16px 16px ;
	}
	.radioTxt{
		margin-right: 10px;
	}
	.cellCont01{
		flex: 8;
		display: flex;
		align-items: center;
		word-break: break-all;
	}
	.cont-circle{
	    width: 10px;
	    height: 10px;
	    border-radius: 10px;
	    background: #00a3c9;
	    display: inline-block;
	    position: relative;
	}
	.cont-circle::after{
		content: '';
	    width: 14px;
	    height: 14px;
	    border: 1px solid #004eff;
	    border-radius: 12px;
	    position: absolute;
	    left: -3px;
	    top: -3px;
	}
	.cont-circle-grey{
	    width: 10px;
	    height: 10px;
	    border-radius: 10px;
	    background: #999;
	    display: inline-block;
	    position: relative;
	}
	.cont-circle-grey::after{
		content: '';
	    width: 14px;
	    height: 14px;
	    border: 1px solid #000240;
	    border-radius: 12px;
	    position: absolute;
	    left: -3px;
	    top: -3px;
	}
	.cont-content{
		margin-left: 10px;
	}
	.cont-border{
		width: 1px;
	    height: 20px;
	    background: #908383;
	    display: inline-flex;
	    margin-right: 15px;
	    position: relative;
	    vertical-align: text-bottom;
	    margin-left: 3px;
	}
	
	.cont-content2{
		margin-left: 23px;
	}
</style>


// WEBPACK FOOTER //
// src/components/worksheet/detail/WcWorkD.vue